import { EMPTY_SCAFFOLD_SELECTION } from "../interface";
import { ScaffoldState } from "./interface";
import { hasAnySelection } from "./scaffoldSelection";

/**
 * Handles the CLICK_OUTSIDE action by clearing the active selection and anchor.
 * This action is only dispatched when there is an active selection; the else branch
 * is retained as a safety net and is marked with an Istanbul ignore pragma.
 *
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the selection and anchor cleared, or the
 *          same state reference if there was no selection to clear.
 */
export const scr_clickOutside = <T>(state: ScaffoldState<T>): ScaffoldState<T> => {
  if (hasAnySelection(state.selection)) {
    return { ...state, selection: EMPTY_SCAFFOLD_SELECTION, selectionAnchor: null };
  }
  return state;
};
